export default "__VITE_ASSET__YoUR_5We__"